import { createSubjectUseCase } from '@src/main/modules/messages/application/use-cases/create/create-subject.usecase';
import { CreateSubjectRequest } from '@src/main/modules/messages/infrastructure/dto/createSubjectRequest';
import { createSubjectHttpRepository } from '@src/main/modules/messages/infrastructure/repository/SubjectHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useCreateSubject = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createSubjectHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (data: CreateSubjectRequest) => {
      if (!repository) throw new Error('Repository not initialized');
      return await createSubjectUseCase(data, tokenProvider);
    },
  });
};
